<script>
	import { SelectionStatus } from '@/Constants/Selection.js';
	import { Sport } from '@/Constants/Sport.js';

	export let selection;
	export let race;
	export let showWeight = true;
	export let showJockeyTrainer = true;
</script>

<!-- Selection Name, Number, Barrier, Weight, Jockey, Trainer based on racing type -->
{#if selection}
	<div>
		<div class="ml-2 text-sm font-bold">
			{#if race.race_type.id !== Sport.Harness}{selection.number}.{/if}
			{selection.name}
			{#if selection.barrier}
				<span class="font-normal">({selection.barrier})</span>
			{/if}
			<span class="ml-2 text-xs font-normal text-grey">
				{selection.last_ten_starts || ''}
			</span>
		</div>
		{#if selection.status.id === SelectionStatus.Active}
			<div class="ml-2 text-grey">
				{#if race.race_type.id === Sport.Gallop}
					<div>
						{#if showWeight}
							<div class="py-1">
								<span class="">{selection.weight + 'kg' || ''}</span>
							</div>
						{/if}
						{#if showJockeyTrainer}
							<div>
								<span>J:</span>
								{selection.jockey || 'N/A'}
								<span class="ml-2">T:</span>
								{selection.trainer || 'N/A'}
							</div>
						{/if}
					</div>
				{:else if race.race_type.id === Sport.Harness && showJockeyTrainer}
					<span class="pt-1">D:</span>
					{selection.jockey || 'N/A'}
				{:else if race.race_type.id === Sport.Greyhound && showJockeyTrainer}
					<div>
						<span>T:</span>
						{selection.trainer || 'N/A'}
					</div>
				{/if}
			</div>
		{/if}
	</div>
{/if}
